module.exports = __webpack_public_path__ + "media/contact_us/ig-logo-7c64d214.png";